import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import axios from 'axios'

// The Pinia store with persisted state
export const useUserStore = defineStore('user', () => {
  const systoker = ref('')
  const account = ref('')
  const isLoggedIn = ref(false)
  const errorMessage = ref('')
  const errorMessageRegiedt = ref('')
  const isLoading = ref(false)
  const isAccOk = ref(false)
  const nickname = ref('')
  const companyNo = ref('')
  const cellPhone = ref('')
  const city = ref('')
  const zipCode = ref('')
  const address = ref('')
  const enddate = ref('')
  const isLoggingOut = ref(false)
  const agentInfo = ref<{ name?: string; [key: string]: any }>({})
  const isDev = false
  


  const serversid = 'https://video.qianchih.net:5006'
  //const serversid = 'http://localhost:5003'

  // axios.interceptors.request.use(
  //   (config) => {
  //     config.withCredentials = true
  //     return config
  //   },
  //   (error) => Promise.reject(error)
  // )
  // axios.interceptors.request.use(
  //   (config) => {
  //     config.withCredentials = true
  //     const token = systoker.value || localStorage.getItem('token')
  //     if (token) {
  //       config.headers['Authorization'] = `Bearer ${token}`
  //     }
  //     return config
  //   },
  //   (error) => Promise.reject(error)
  // )





  const TransferInsert = async (
    useraccount: string,
    plan: string,
    amount: number,
    last5: string,
    note: string
  ) => {
    
    try {
      
      const response = await axios.post(`${serversid}/api/transferInsert`, {  
        useraccount,
        plan,
        amount,
        last5,
        note
      }, {
        withCredentials: true
      })
  
      if (response.data.success) {
        errorMessageRegiedt.value = ''
        return true
      } else {
        errorMessageRegiedt.value = response.data.message || '轉帳登錄失敗'
        return false
      }
    } catch (error: any) {
      errorMessageRegiedt.value = error.response?.data?.message || error.response?.data?.error || '轉帳登錄失敗，請稍後再試'
      return false
    } finally {
      
    }
  }

  // utils/api.ts 或 store/user.ts
const getaccountbycompanyNo = async (Account: string) => {
  try {
    const response = await axios.post(`${serversid}/api/getListByCompanyNo`, {
      Account  // ✅ 必須與後端要求的 key 相同
    }, {
      withCredentials: true
    })

    // ✅ 成功回傳格式應為 { success: true, data: [...] }
    if (response.data.success) {
      return response.data.data || []
    } else {
      console.error('錯誤訊息:', response.data.error || '未知錯誤')
      return []
    }

  } catch (error: any) {
    console.error('例外錯誤:', error.response?.data?.error || '無法獲取資料')
    return []
  }
}

  

  const getRecentTransfers = async (useraccount: string) => {
    try {
      const response = await axios.post(`${serversid}/api/getRecentTransfers`, {
        useraccount
      }, {
        withCredentials: true
      })
  
      if (response.data.success) {
        const recentRecords = response.data.data
        console.log('最近三筆轉帳紀錄:', recentRecords)
        return recentRecords
      } else {
        console.error('獲取紀錄失敗:', response.data.message)
        return []
      }
    } catch (error: any) {
      console.error('錯誤:', error.response?.data?.message || '無法獲取資料')
      return []
    }
  }
  

  const login = async (userAccount: string, password: string) => {
    isLoading.value = true
    errorMessage.value = ''
    try {
      console.log('Sending login request to:', `${serversid}/api/login`)
      const response = await axios.post(
        `${serversid}/api/login`,
        { Account: userAccount, password },
        {
          withCredentials: true,
          headers: { 'Content-Type': 'application/json' },
        }
      )
  
      if (response.status === 200 && response.data.success) {
        const token = response.data.token
        if (!token) {
          throw new Error('No token received from server')
        }
        console.log('token is :',token)
        nickname.value = response.data.nickname
        enddate.value = response.data.enddate
        account.value = userAccount
        systoker.value = token
        isLoggedIn.value = true
  
        //localStorage.setItem('token', token)
        //localStorage.setItem('account', userAccount)
  
        console.log('Login successful, account:', account.value)
      } else {
        errorMessage.value = response.data.message || response.data.error || '登入失敗'
      }
    } catch (error: any) {
      console.error('Login error:', error.response || error)
      errorMessage.value =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `登入異常 (錯誤碼: ${error.response?.status || '未知'})`
    } finally {
      isLoading.value = false
    }
  }

  // const login = async (userAccount: string, password: string) => {
  //   isLoading.value = true;
  //   errorMessage.value = '';
  //   try {
  //     console.log('Sending login request to:', `${serversid}/api/login`); // Debug URL
  //     const response = await axios.post(`${serversid}/api/login`, {
  //       Account: userAccount,
  //       password
  //     }, {
  //       withCredentials: true,
  //       headers: {
  //         "Content-Type": "application/json"
  //       }
  //     });
  
  //     if (response.status === 200 && response.data.success) {
  //       nickname.value = response.data.nickname;
  //       enddate.value = response.data.enddate;
  //       account.value = userAccount;
  //       systoker.value = response.data.token;
  //       isLoggedIn.value = true;
  
  //       localStorage.setItem('token', response.data.token);
  //       localStorage.setItem('account', userAccount);
  
  //       console.log('Login successful, account:', account.value);
  //     } else {
  //       errorMessage.value = response.data.message || response.data.error || '登入失敗';
  //     }
  //   } catch (error: any) {
  //     console.error('Login error:', error.response || error); // Detailed logging
  //     if (error.response) {
  //       errorMessage.value =
  //         error.response.data?.message ||
  //         error.response.data?.error ||
  //         `登入異常 (錯誤碼: ${error.response.status})`;
  //     } else {
  //       errorMessage.value = '無法連接到伺服器，請稍後再試。';
  //     }
  //   } finally {
  //     isLoading.value = false;
  //   }
  // };


  watch(isLoggedIn, (newValue, oldValue) => {
    console.log(`isLoggedIn changed from ${oldValue} to ${newValue}`)
    console.trace()
  })

  // const initializeStore = () => {
  //   const storedUser = localStorage.getItem('user')
  //   if (storedUser) {
  //     const userData = JSON.parse(storedUser)
  //     if (userData.isLoggedIn) {
  //       isLoggedIn.value = true
  //       account.value = userData.account
  //       nickname.value = userData.nickname
  //       enddate.value = userData.enddate
  //       console.log('Restored user state from localStorage:', userData)
  //     }
  //   }
  // }
  const initializeStore = async () => {
    console.log('Initializing user store...');
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      console.log('Found stored user:', storedUser);
      const userData = JSON.parse(storedUser);
      const isTokenValid = await checkToken();
      console.log('Token valid:', isTokenValid);
      if (isTokenValid && userData.isLoggedIn) {
        isLoggedIn.value = true;
        account.value = userData.account;
        nickname.value = userData.nickname;
        enddate.value = userData.enddate;
        console.log('Restored user state from localStorage:', userData);
      } else {
        console.log('Resetting store due to invalid token or user data');
        resetStore();
      }
    } else {
      console.log('No stored user found');
    }
  };

  // const resetStore = () => {
  //   account.value = '';
  //   isLoggedIn.value = false;
  //   nickname.value = '';
  //   enddate.value = '';
  //   systoker.value = '';
  //   errorMessage.value = '';
  //   localStorage.removeItem('user');
  //   localStorage.removeItem('token');
  //   localStorage.removeItem('account');
  // };

  const getUserInfo = async () => {
    console.log('send getuserinfo value', account.value)
    try {
      const response = await axios.post(`${serversid}/api/getuserinfo`, {
        Account: account.value
      }, {
        withCredentials: true
      })
      const data = response?.data
      if (data?.success) {
        nickname.value = data.NickName || ''
        companyNo.value = data.CompanyNo || ''
        cellPhone.value = data.CellPhone || ''
        city.value = data.City || ''
        zipCode.value = data.ZipCode || ''
        address.value = data.Address || ''
        console.log('send success userInfovalue', account.value)
      } else {
        errorMessage.value = data?.message || '查詢帳號資訊失敗'
      }
    } catch (error) {
      console.error('Error during request:', error)
      errorMessage.value = '伺服器錯誤'
    }
  }

  const updateUserInfo = async (userData) => {
    console.log('updateUserInfo called with userData:', userData)
    console.log('Account:', account.value)
    isLoading.value = true
    errorMessage.value = ''
    try {
      const response = await axios.post(`${serversid}/api/updateuserinfo`, {
        Account: account.value,
        Nickname: userData.nickname,
        CompanyNo: userData.companyNo,
        CellPhone: userData.cellPhone,
        City: userData.city,
        ZipCode: userData.zipCode,
        Address: userData.address
      }, {
        withCredentials: true
      })
      console.log('API response:', response.data)
      if (response.data.success) {
        nickname.value = userData.nickname
        companyNo.value = userData.companyNo
        cellPhone.value = userData.cellPhone
        city.value = userData.city
        zipCode.value = userData.zipCode
        address.value = userData.address
        return true
      } else {
        errorMessage.value = response.data.message || '更新資料失敗'
        return false
      }
    } catch (error) {
      console.error('Error during update:', error)
      errorMessage.value = '伺服器錯誤'
      return false
    } finally {
      isLoading.value = false
      console.log('isLoading reset to:', isLoading.value)
    }
  }

  const getAccountInfo = async () => {
    console.log('send getAccountInfo value', account)
    try {
      const response = await axios.post(`${serversid}/api/getaccountinfo`, {
        Account: account.value
      }, {
        withCredentials: true
      })
      if (response.data.success) {
        nickname.value = response.data.NickName || ''
        enddate.value = response.data.EndDate || ''
      } else {
        errorMessage.value = response.data.message || '查詢帳號資訊失敗'
      }
    } catch (error) {
      console.error('Error during request:', error)
      errorMessage.value = '伺服器錯誤'
    }
  }



  const CheckAccount = async (userAccount: string) => {
    try {
      const response = await axios.post(`${serversid}/api/checkaccount`, {
        Account: userAccount
      }, {
        withCredentials: true
      })

      await new Promise(resolve => setTimeout(resolve, 7000))

      if (response.status === 200 && response.data.success) {
        isAccOk.value = true
        errorMessageRegiedt.value = ''
      } else {
        isAccOk.value = false
        errorMessageRegiedt.value = response.data.message || '帳號無法使用'
      }
    } catch (error: any) {

      await new Promise(resolve => setTimeout(resolve, 7000)) 
      
      isAccOk.value = false
      errorMessageRegiedt.value =
        error.response?.data?.error || error.response?.data?.message || '伺服器錯誤，請稍後再試'
    }
  }



  const UserAdd = async (
    userAgent: string, userNick: string, userCompantNo:string , userCellPhone: string,
    userAccount: string, userPassword: string, userCity: string,
    userZip: string, userAddress: string
  ) => {
    isLoading.value = true
    try {
      const response = await axios.post(`${serversid}/api/register`, {
        Agent: userAgent,
        Nickname: userNick,
        CompanyNo: userCompantNo,
        CellPhone: userCellPhone,
        Account: userAccount,
        Password: userPassword,
        City: userCity,
        Zip: userZip,
        Address: userAddress
      }, {
        withCredentials: true
      })
      if (response.data.success) {
        errorMessageRegiedt.value = ''
        return true
      } else {
        errorMessageRegiedt.value = response.data.message || '註冊失敗'
        return false
      }
    } catch (error: any) {
      errorMessageRegiedt.value =
        error.response?.data?.message || error.response?.data?.error || '註冊失敗，請稍後再試'
      return false
    } finally {
      isLoading.value = false
    }
  }


  // const checkToken = async () => {
  //   const storedAccount = localStorage.getItem('account')
  //   if (!storedAccount) {
  //     return false
  //   }
  //   try {
  //     const response = await axios.post(`${serversid}/api/gettoken`, {
  //       Account: storedAccount,
  //     }, {
  //       headers: { 'Content-Type': 'application/json' },
  //       withCredentials: true,
  //     })
  //     return response.status === 200 && response.data.success
  //   } catch (error) {
  //     return false
  //   }
  // }
  const checkToken = async () => {
    console.log('Account:',account.value, 'kt:',systoker.value)
    
    try {
    const response = await axios.post(
      `${serversid}/api/gettoken`,
      {
        Account: account.value,
        token: systoker.value,
      },
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      }
    )

    if (response.status === 200 && response.data.success) {      
      return true
    } else {
      // isLoggedIn.value = false      
      return false
    }
  } catch (error) {
    console.error('Token check failed:', error)
    isLoggedIn.value = false
    systoker.value = ''
    account.value = ''
    
    // localStorage.removeItem('token')
    // localStorage.removeItem('account')
    // localStorage.removeItem('user')
    return false
  }

}


  const logout = async (userAccount: string) => {
    console.log('Attempting to log out user:', userAccount)
    if (!isLoggedIn.value) {
      console.warn('Logout called but user is not logged in.')
      errorMessage.value = '尚未登入，無需登出'
      return
    }
    if (!userAccount) {
      console.warn('Logout called with empty userAccount.')
      errorMessage.value = '無效的帳號資訊，無法登出'
      return
    }
    isLoading.value = true;
    try {
      const response = await axios.post(
        `${serversid}/api/logout`,
        { Account: userAccount },
        { withCredentials: true }
      )
      if (response.data.success) {
        resetStore()
        console.log('User logged out successfully.')
      } else {
        errorMessage.value = response.data.message || '登出失敗'
        console.warn('Logout failed:', response.data.message)
      }
    } catch (error: any) {
      console.error('Logout error:', error)
      errorMessage.value =
        error.response?.data?.message ||
        error.response?.data?.error ||
        '登出失敗，請稍後再試'
    } finally {
      resetStore()
      isLoading.value = false
    }
  }
  
  const resetStore = () => {
    account.value = ''
    isLoggedIn.value = false
    nickname.value = ''
    enddate.value = ''
    systoker.value = ''
    errorMessage.value = ''
    systoker.value = ''
    // localStorage.removeItem('user');
    // localStorage.removeItem('token');
    // localStorage.removeItem('account');
  };


  // const logout = async (userAccount: string) => {
  //   console.log('Attempting to log out user:', userAccount)
  //   if (!isLoggedIn.value) {
  //     console.warn('Logout called but user is not logged in.')
  //     errorMessage.value = '尚未登入，無需登出'
  //     return
  //   }
  //   if (!userAccount) {
  //     console.warn('Logout called with empty userAccount.')
  //     errorMessage.value = '無效的帳號資訊，無法登出'
  //     return
  //   }
  //   isLoading.value = true
  //   try {
  //     const response = await axios.post(`${serversid}/api/logout`, {
  //       Account: userAccount
  //     }, {
  //       withCredentials: true
  //     })
  //     if (response.data.success) {
  //       account.value = ''
  //       isLoggedIn.value = false
  //       nickname.value = ''
  //       enddate.value = ''
  //       errorMessage.value = ''
  //       localStorage.removeItem('user')
  //       localStorage.removeItem('token')
  //       localStorage.removeItem('account')

  //       console.log('User logged out successfully.')
  //     } else {
  //       errorMessage.value = response.data.message || '登出失敗'
  //       console.warn('Logout failed:', response.data.message)
  //     }
  //   } catch (error: any) {
  //     console.error('Logout error:', error)
  //     errorMessage.value =
  //       error.response?.data?.message ||
  //       error.response?.data?.error ||
  //       '登出失敗，請稍後再試'
  //   } finally {
  //     isLoading.value = false
  //   }
  // }

  // Persist the store's state to localStorage
  return {
    account,
    isLoggedIn,
    errorMessage,
    errorMessageRegiedt,
    isLoading,
    isAccOk,
    nickname,
    companyNo,
    cellPhone,
    city,
    zipCode,
    address,
    enddate,
    agentInfo,
    isLoggingOut,
    systoker,
    login,
    logout,
    CheckAccount,
    UserAdd,
    updateUserInfo,
    getUserInfo,
    getAccountInfo,
    TransferInsert,
    getRecentTransfers,
    getaccountbycompanyNo,
    checkToken,
    resetStore,
    initializeStore
  }
}, {
  persist: {
    strategies: [
      {
        key: 'user',
        storage: localStorage,
        paths: ['account', 'isLoggedIn', 'nickname', 'enddate']
      }
    ]
  }
})